/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const WidgetTooltip = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
}));

export const WidgetTitle = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurface,
  marginBottom: theme.spacing(4),
}));

export const AmountText = styled(Typography)(({theme}) => ({
  fontSize: '32px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.good.main,
  marginBottom: theme.spacing(1),

  span: {
    fontSize: '14px',
    color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  },
}));

export const SubTextContainer = styled(Box)({
  marginTop: 'auto',
});

export const SubText = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  marginTop: theme.spacing(2),
}));

export const MonthText = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  marginTop: theme.spacing(2),
}));

export const NotAvailableText = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
}));
